import { fetchApi } from '../utils/fetchApi'

export const messageList = () => fetchApi({
  path: '/message/list',
})
